// extracted by mini-css-extract-plugin
export default {"subitemSelect":"subitem-select__oalDlMMl"};